import * as React from 'react'
import {MapboxOverlay, MapboxOverlayProps} from '@deck.gl/mapbox/typed';;
import {useControl} from 'react-map-gl';

interface IProps extends MapboxOverlayProps {
  interleaved?: boolean;
}

const DeckGLOverlay = (props: IProps): any => {
  const overlay = useControl<MapboxOverlay>(() => new MapboxOverlay(props));
  overlay.setProps(props);
  return null;
}

export { DeckGLOverlay }
